import React from 'react'
import { Helmet } from "react-helmet";
import green_switch_cma from '../assets/images/green_switch_cma.png'
import { Link } from "react-router-dom";
import purpledot from "../assets/images/purple_squre_dots.b6e7dbcc.svg";
import yellowdot from "../assets/images/yellow_squre_dots.a8deef14.svg";
import loca from '../assets/images/loca.svg'
import company from '../assets/images/company.svg'
import spec from '../assets/images/spec.svg'
import ea1 from '../assets/images/ea1.svg'
import ea2 from '../assets/images/ea2.svg'
import ea3 from '../assets/images/ea3.svg'
import ea4 from '../assets/images/ea4.svg'
import ea5 from '../assets/images/ea5.svg'
import ea6 from '../assets/images/ea6.svg'
import ea7 from '../assets/images/ea7.svg'
import ea8 from '../assets/images/ea8.svg'
import s1 from '../assets/images/s1.png'
import s2 from '../assets/images/s2.png'
import s3 from '../assets/images/s3.png'
import CMA_img from '../assets/images/CMA.png'

function CmaSalary() {
    return (
        <>
            <Helmet>
                <title>US CMA Salary in India by KC Globed: Affordable CMA Certification</title>

                <meta name="description" content="Discover the US CMA course fees in India with KC Globed. Get detailed information on costs, affordable pricing and expert training to achieve CMA certification." />

                <link rel="canonical" href="" />

                <meta name="robots" content="index, follow" />
            </Helmet>

            <div className="overflow-hidden bg-placement-hero bg-cover w-full">
                <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
                    <img src={green_switch_cma} alt="CMA Fees" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[0] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
                    <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
                        <div className="mx-auto lg:max-w-5xl">
                            <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[38%] w-[60%] mb-2 lg:leading-[56px]"><span className="block">CMA Salary
                                in India</span></h1>

                            <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                                    >
                                        Enquiry Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative p-4 md:p-8 lg:p-10 pt-[91px] pb-[131px]">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div className="flex flex-col items-center">
                    <div tabindex="0" style={{ transform: 'none' }}>
                        <div className="mx-auto grid items-center xs:max-w-xl lg:max-w-5xl group h-full">
                            <div className="flex flex-col ml-0 lg:ml-6">
                                <h2 className="block flex flex-col text-3xl font-semibold text-gray-800 sm:text-4xl md:text-4xl text-center mt-4 lg:mt-0">
                                    <span className="uppercase text-xl"> Career Prospects</span>
                                    <span className="text-primary_text mt-3 mb-3">
                                        And CMA Role</span>
                                </h2>
                                <p className="text-[15px] text-base md:text-medium text-center text-dark_text">
                                    Certified Management Accountant (CMA) professionals are in high demand across global finance and accounting sectors. With expertise in strategic management, financial analysis, and budgeting. The CMA is not just an accounting role—it’s a leadership credential. CMAs are responsible for making critical business decisions, driving company growth, and optimizing financial performance. Their skills are highly sought-after in industries such as manufacturing, IT, consulting, banking, and FMCG.
                                </p>
                            </div>
                            <img className="w-[97%] mt-10 lg:ml-[3%]" src={CMA_img} alt="Career Prospects CMA Role" />
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>

            <div className="p-8 md:p-8 lg:p-10 bg-[#f5f9f3]">
                <div className="flex flex-col items-center">
                    <h2 className="block mb-1 mt-4 text-2xl md:text-4xl font-bold text-gray-700  text-center">
                        US CMA <span className="text-primary_text">Salary in India</span>
                    </h2>
                    <p className="lg:w-[60rem] mx-auto mt-3 mb-[41px] text-lg text-medium text-dark_text text-center">
                        The US CMA salary in India varies depending on experience, location, and company size. On average:
                    </p>
                    <div tabindex="0 " className="">
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-4xl mb-5">
                            <div
                                className="box transform transition-transform duration-300 hover:scale-110"
                                tabindex="0"
                            >
                                <div className="relative overflow-hidden">
                                    <div>
                                        <div className="flex items-center h-auto lg:h-[37rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                                            <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                                                <img
                                                    src={s1}
                                                    alt="Entry-Level Salaries"
                                                    className="h-[9rem]"
                                                />
                                            </div>
                                            <div className="px-4 text-justify">
                                                <p style={{ color: 'rgb(0, 55, 104)' }} className="text-start font-bold text-xl pb-2">
                                                    Entry-Level Salaries
                                                </p>
                                                <p className="text-start text-md font-light pb-16 text-gray-700">
                                                    Freshers holding a US CMA certification can expect to earn between ₹5–7 LPA in India. This competitive starting salary reflects the growing demand for globally certified management accountants in top companies.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="box  transform transition-transform duration-300 hover:scale-110"
                                tabindex="0"
                            >
                                <div className="relative overflow-hidden">
                                    <div>
                                        <div className="flex items-center h-auto lg:h-[37rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                                            <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                                                <img
                                                    src={s2}
                                                    alt="Mid-Level Salaries"
                                                    className="h-[9rem]"
                                                />
                                            </div>
                                            <div className="px-4 text-justify">
                                                <p style={{ color: 'rgb(0, 55, 104)' }} className="text-start font-bold text-xl pb-2">
                                                    Mid-Level Salaries
                                                </p>
                                                <p className="text-start text-md font-light pb-16 text-gray-700">
                                                    Mid-level professionals with a US CMA certification typically earn between ₹8–12 LPA. Their experience combined with global financial expertise makes them valuable assets to organizations seeking strategic financial leadership.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="box  transform transition-transform duration-300 hover:scale-110"
                                tabindex="0"
                            >
                                <div className="relative overflow-hidden">
                                    <div>
                                        <div className="flex items-center h-auto lg:h-[37rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                                            <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                                                <img
                                                    src={s3}
                                                    alt="Senior-Level Salaries"
                                                    className="h-[9rem]"
                                                />
                                            </div>
                                            <div className="px-4 text-justify">
                                                <p style={{ color: 'rgb(0, 55, 104)' }} className="text-start font-bold text-xl pb-2">
                                                    Senior-Level Salaries
                                                </p>
                                                <p className="text-start text-md font-light pb-16 text-gray-700">
                                                    Senior CMAs in managerial or leadership roles often earn ₹15 LPA and above. Their advanced expertise in financial planning, analysis, and strategic decision-making positions them as key drivers of organizational growth.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="relative lg:py-1 lg:px-10 lg:py-0 pt-[71px] pb-[111px] px-6">
                <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                                    <span className="uppercase text-xl">Factors Influencing</span>
                                </h2>
                                <h2 className="mt-2 block text-2xl md:text-4xl font-bold text-primary_text">
                                    CMA USA Salary in India
                                </h2>
                                <p className="text-lg text-medium text-dark_text text-center">
                                    Several factors can impact CMA USA salary in India, including:
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[21rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(255, 247, 235)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                1
                                                            </h3>
                                                            <img className="w-16 h-16" src={loca} alt="Location" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Location (metro cities offer higher pay)
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    Location matters when it comes to salary—CMA professionals in metro cities like Mumbai, Delhi, and Bangalore often enjoy significantly higher pay packages. The demand for financial expertise in urban corporate hubs drives up compensation and career growth opportunities.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[21rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(245, 249, 243)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                2
                                                            </h3>
                                                            <img className="w-16 h-16" src={company} alt="Company" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Additional qualifications (like CPA or MBA)
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    Additional qualifications like CPA or MBA can significantly boost your career prospects and earning potential as a CMA. They showcase your broader financial expertise and leadership capabilities, making you a top choice for senior roles.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[21rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(235, 243, 248)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                3
                                                            </h3>
                                                            <img className="w-16 h-16" src={spec} alt="Specialization" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Company reputation and global presence
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    Working with a reputable company that has a strong global presence can elevate your CMA career by offering international exposure and diverse opportunities. Such companies often provide better compensation, structured growth paths, and recognition in the industry.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
            </div>

            <div className="lg:py-1 lg:px-10 py-0 px-6 mt-[-31px] lg:mb-5">
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto px-4 sm:px-6 lg:px-8 py-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className="block text-2xl md:text-4xl font-bold text-gray-800">
                                    <span className="uppercase text-xl">Career Prospects</span>
                                </h2>
                                <h2 className="mt-2 block text-2xl md:text-4xl font-bold text-primary_text">
                                    for CMA
                                </h2>
                                <p className="mt-4 text-md text-medium text-dark_text font-light">
                                    The CMA USA designation opens doors to global opportunities. Whether working in India or abroad, CMAs are equipped to take on high-impact roles in finance, operations, and strategy. As businesses increasingly value data-driven decision-making, the demand for CMAs continues to rise.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="lg:max-w-3xl px-4 py-6 justify-center items-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 justify-center items-center">
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(255, 247, 235)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                1
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea1} alt=" Banking and Financial Services" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Banking and Financial Services
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs play a vital role in financial analysis, investment planning, and risk management.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(245, 249, 243)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                2
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea2} alt="Manufacturing and Production" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Manufacturing and Production
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs help control costs, streamline operations, and improve production efficiency.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(235, 243, 248)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                3
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea3} alt="Consulting and Advisory Services" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Consulting and Advisory Services
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs provide expert insights in financial strategy and performance optimization.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(255, 247, 235)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                4
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea4} alt="Healthcare and Pharmaceuticals" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Healthcare and Pharmaceuticals
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs assist in budgeting, compliance, and cost-effective resource allocation.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(245, 249, 243)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                5
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea5} alt="FMCG (Fast-Moving Consumer Goods)" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            FMCG (Fast-Moving Consumer Goods)
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs manage pricing, supply chain costs, and profitability tracking.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                tabindex="0"
                                className=" transform transition-transform duration-300 hover:scale-110"
                            >
                                <div
                                    className="group flex flex-col h-[15rem] rounded-xl transition shadow-[inset_2px_3px_6px_#46464620]"
                                    href="#"
                                    style={{ backgroundColor: "rgb(235, 243, 248)" }}
                                >
                                    <div
                                        className="relative overflow-hidden"
                                        style={{ width: "fit-content" }}
                                    >
                                        <div style={{ opacity: "1", transform: "none" }}>
                                            <div className="p-6 flex-grow">
                                                <div className="flex items-start">
                                                    <div className="grow flex flex-col items-start">
                                                        <div className="w-full flex flex-row items-center justify-between">
                                                            <h3 className="text-[3rem] font-semibold text-primary_text">
                                                                6
                                                            </h3>
                                                            <img className="w-16 h-16" src={ea6} alt="Retail and E-commerce" />
                                                        </div>
                                                        <h3 className="font-semibold text-[#6C38CC] min-w-[186px]">
                                                            Retail and E-commerce
                                                        </h3>
                                                    </div>
                                                </div>
                                                <p className="text-xs font-light mr-5">
                                                    CMAs optimize inventory costs, sales forecasting, and financial performance.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-[#512A99] px-6 py-3 bg-center bg-no-repeat bg-cover mb-4">
                <div className="flex flex-col items-center">
                    <div className="relative overflow-hidden">
                        <div className="max-w-[85rem] mx-auto py-10">
                            <div className="max-w-3xl text-center mx-auto">
                                <h2 className="text-white text-2xl">The role of a Certified Management Accountant (CMA) is both prestigious and rewarding, opening doors to diverse career opportunities and attractive salaries in India</h2>
                                <p className="mt-4 text-md text-medium text-white text-[16px]">
                                    With the growing need for financial planning, analysis, and strategic decision-making, CMAs are uniquely positioned to drive organizational success and advance in their careers. This globally recognized credential enhances professional credibility and significantly boosts earning potential. Enrolling in a well-structured CMA course is a smart first step toward unlocking these opportunities and achieving long-term career goals.
                                </p>
                                <p className="mt-8 text-md text-medium text-white  text-[16px]">
                                    <span className="bg-white inline-block text-[#512A99] text-xl p-3 mt-2 rounded-xl font-semibold">For more detailed insights and up-to-date information, visit
                                        <a href="https://www.kcglobed.com/"> KC GlobEd.</a></span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default CmaSalary;
